import React, { useMemo } from 'react'
import { Control, Controller, FieldErrors } from 'react-hook-form';
import Select from 'react-select';
import clsx from 'clsx';
import { IndexFilter } from '../../../../services/properties/schema/IndexFilterSchema';
import useIndexGroups from '../../../../services/group/hooks/useIndexGroups';

interface GroupFilterComponentProps {
    control: Control<IndexFilter>,
    errors: FieldErrors<IndexFilter>
}

const ALL_OPTION = { value: '', label: 'All Groups' };

const GroupFilterComponent: React.FC<GroupFilterComponentProps> = ({ control, errors }) => {
    const { data, isLoading } = useIndexGroups({ all: true, orderBy: 'name', sort: 'asc' });

    const options = useMemo(
        () => [ALL_OPTION, ...(data?.data ?? []).map((group) => ({ value: group.id, label: group.name }))],
        [data]
    );

    return (
        <div className='form-group' style={{ minWidth: 200 }}>
            <label className='form-label'>Group</label>
            <Controller
                control={control}
                name='group_id'
                render={({ field }) => (
                    <Select
                        key={field.value}
                        {...field}
                        className={clsx('', { 'is-invalid': errors.group_id })}
                        options={options}
                        isLoading={isLoading}
                        isSearchable
                        value={options.find((option) => option.value === field.value) ?? ALL_OPTION}
                        onChange={(selectedOption) => {
                            if (selectedOption) {
                                field.onChange(selectedOption.value);
                            }
                        }}
                    />
                )}
            />
            {errors.group_id && <div className="invalid-feedback">{errors.group_id.message}</div>}
        </div>
    )
}

export default GroupFilterComponent
